import React from "react";
import { Route, Redirect } from "react-router";

import HomeView from "../views/HomeView/HomeView";
import MovieMakerView from "../views/HomeView/MovieMakerView";
import VodView from "../views/VodView/VodView";
import NewsDetailsView from "../views/VodView/NewsDetailsView";
import MovieGalleryView from "../views/MoviesView/MovieGalleryView";
import TeamView from "../views/AboutView/TeamView";
import PresentationView from "../views/AboutView/PresentationView";
import Template1 from "../views/AboutView/Template1";
import Template2 from "../views/AboutView/Template2";
import TemplateImgTopLarge from "../views/AboutView/TemplateImgTopLarge";
import TemplateMosaic from "../views/AboutView/TemplateMosaic";
import HistoricView from "../views/HistoricView/HistoricView";
import ActivityView from "../views/VodView/ActivityView";
import SearchGallery from "../views/SearchView/SearchGallery";
import ActivityGalleryView from "../views/ActivitiesView/ActivityGalleryView";
// import PressKitView from '../views/AboutView/PressKitView'
import PressReleaseView from "../views/AboutView/PressReleaseView";
import NewsGalleryView from "../views/NewsView/NewsGalleryView";
import SponsorFullView from "../views/SponsorView/SponsorFullView";
import TicketFormView from "../views/AboutView/TicketFormView";
import FestProgramView from "../views/AboutView/FestProgramView";
import NotFoundView from "../views/NotFoundView/NotFoundView";
import ProgramFullView from "../views/ProgramView/ProgramFullView";
import NewsletterView from "../views/AboutView/NewsletterView";

export default (store, initialState) => {
  // console.log('store!!!!!!', initialState.selectedScope)
  return (
    <div className="container-fluid">
      <Route path="/festa" component={HomeView} />
      <Route path="/distribuicao" component={MovieMakerView} />
      <Route exact path="/filmes/:tagid" component={MovieGalleryView} />
      <Route exact path="/filmes/:tagid/" component={MovieGalleryView} />
      <Route exact strict path="/filme/:id/" component={VodView} />
      <Route exact strict path="/filme/:id" component={VodView} />
      <Route exact strict path="/filmes/" component={MovieGalleryView} />
      <Route exact strict path="/filmes" component={MovieGalleryView} />
      <Route exact strict path="/actividade/:id" component={ActivityView} />
      <Route exact strict path="/atividades" component={ActivityGalleryView} />
      <Route exact strict path="/programacao/" component={ProgramFullView} />
      <Route exact strict path="/programacao" component={ProgramFullView} />
      <Route exact strict path="/newsletter/" component={NewsletterView} />
      <Route exact strict path="/newsletter" component={NewsletterView} />

      <Route exact strict path="/equipa/" component={TeamView} />
      <Route exact strict path="/equipa" component={TeamView} />

      <Route exact strict path="/presskit" component={PressReleaseView} />
      <Route
        exact
        strict
        path="/materiais_apoio"
        component={PressReleaseView}
      />
      <Route exact strict path="/comunicados/" component={PressReleaseView} />
      <Route exact strict path="/comunicados" component={PressReleaseView} />
      <Route exact strict path="/apresentacao/" component={PresentationView} />
      <Route exact strict path="/apresentacao" component={PresentationView} />
      <Route exact strict path="/noticia/:id/" component={NewsDetailsView} />
      <Route exact strict path="/noticia/:id" component={NewsDetailsView} />
      <Route exact strict path="/noticias/" component={NewsGalleryView} />
      <Route exact strict path="/noticias" component={NewsGalleryView} />
      <Route
        exact
        strict
        path="/historico/:page/:id/"
        component={HistoricView}
      />
      <Route
        exact
        strict
        path="/historico/:page/:id"
        component={HistoricView}
      />
      <Route exact strict path="/historico/:page/" component={HistoricView} />
      <Route exact strict path="/historico/:page" component={HistoricView} />
      <Route exact strict path="/pesquisa/" component={SearchGallery} />
      <Route exact strict path="/pesquisa" component={SearchGallery} />
      <Route exact strict path="/programa/" component={FestProgramView} />
      <Route exact strict path="/programa" component={FestProgramView} />

      <Route exact strict path="/404" component={NotFoundView} />
      <Route exact strict path="/t1/*/" component={Template1} />
      <Route exact strict path="/t1/*" component={Template1} />
      <Route exact strict path="/t2/*/" component={Template2} />
      <Route exact strict path="/t2/*" component={Template2} />
      <Route exact strict path="/t3/*/" component={TemplateImgTopLarge} />
      <Route exact strict path="/t3/*" component={TemplateImgTopLarge} />
      <Route exact strict path="/t4/*/" component={TemplateMosaic} />
      <Route exact strict path="/t4/*" component={TemplateMosaic} />
      <Route exact strict path="/acreditacoes/" component={TicketFormView} />
      <Route exact strict path="/acreditacoes" component={TicketFormView} />
      <Route
        exact
        strict
        path="/patrocinadores/*/"
        component={SponsorFullView}
      />
      <Route
        exact
        strict
        path="/patrocinadores/*"
        component={SponsorFullView}
      />

      {initialState.selectedScope === "distrib" ? (
        <Route exact path="/" component={MovieMakerView} />
      ) : (
        <Route exact path="/" component={HomeView} />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/routes/index.js